import React, { PureComponent } from 'react';

import CoreUtils from '../utils/CoreUtils';
import DateTimeUtils from '../utils/DateTimeUtils';

import BooleanEditor from '../metadata/BooleanEditor';
import CutOffEditor from '../metadata/CutOffEditor';
import DateEditor from '../metadata/DateEditor';
import MonthEditor from '../metadata/MonthEditor';
import NumberEditor from '../metadata/NumberEditor';
import SataConfigurationEditor from '../metadata/SataConfigurationEditor';
import SelectEditor from '../metadata/SelectEditor';
import StringEditor from '../metadata/StringEditor';
import StringListEditor from '../metadata/StringListEditor';
import TimeSpanEditor from '../metadata/TimeSpanEditor';

const widthNarrow       = 'Narrow';
const widthNarrowMedium = 'NarrowMedium';
const widthMedium       = 'Medium';
const widthMediumWide   = 'MediumWide';
const widthWide         = 'Wide';
const widthWideFlex     = 'WideFlex';

export default class MetadataEditor extends PureComponent {
  render() {
    if (CoreUtils.isUndefinedOrNull(this.props.metadataRule))
      return (<div />);

    switch (this.props.metadataRule.type) {
      case 'boolean':
        return (
          <BooleanEditor
            disabled={this.props.disabled}
            value={this.props.value}
            height={this.props.height}
            name={this.props.name}
            onValueChanged={this.props.onValueChanged}
            width={this.props.width}
          />
        );
      case 'cutoff':
        return (
          <CutOffEditor
            disabled={this.props.disabled}
            value={this.props.value}
            height={this.props.height}
            name={this.props.name}
            onValueChanged={this.props.onValueChanged}
            width={this.props.width}
          />
        );
      case 'datetime':
        return this.renderDateTime();
      case 'number':
        return (
          <NumberEditor
            disabled={this.props.disabled}
            value={this.props.value}
            height={this.props.height}
            name={this.props.name}
            onValueChanged={this.props.onValueChanged}
            width={this.resolveControlWidth(this.props.metadataRule, '75px')}
          />
        );
      case 'select':
        return (
          <SelectEditor
            disabled={this.props.disabled}
            displayExpr="displayValue"
            value={this.props.value}
            height="28px"
            name={this.props.name}
            onValueChanged={this.props.onValueChanged}
            options={this.props.metadataRule.options}
            width={this.resolveControlWidth(this.props.metadataRule, '185px')}
          />
        );
      case 'sata-config':
        return (
          <SataConfigurationEditor
            disabled={this.props.disabled}
            value={this.props.value}
            height={this.props.height}
            name={this.props.name}
            onValueChanged={this.props.onValueChanged}
            width={this.props.width}
          />
        );
      case 'string':
        return (
          <StringEditor
            disabled={this.props.disabled}
            value={this.props.value}
            height={this.props.height}
            name={this.props.name}
            onValueChanged={this.props.onValueChanged}
            style={this.resolveStringControlWidth(this.props.metadataRule, '285px')}
          />
        );
      case 'string-list':
        return (
          <StringListEditor
            disabled={this.props.disabled}
            value={this.props.value}
            height={this.props.height}
            name={this.props.name}
            onValueChanged={this.props.onValueChanged}
            useCompactEditor={this.props.metadataRule.useCompactEditor}
            style={this.resolveStringControlWidth(this.props.metadataRule, '285px')}
          />
        );
      case 'timespan':
        return (
          <TimeSpanEditor
            disabled={this.props.disabled}
            value={this.props.value}
            height={this.props.height}
            name={this.props.name}
            onValueChanged={this.props.onValueChanged}
            width="75px"
          />
        );
      default:
        return (<div />);
    }
  }

  resolveStringControlWidth(metadataRule, defaultWidth) {
    switch (metadataRule.fieldWidth) {
      case widthNarrow:
        return {
          width: '55px'
        };
      case widthNarrowMedium:
        return {
          width: '100px'
        };
      case widthMedium:
        return {
          width: '165px'
        };
      case widthMediumWide:
        return {
          width: '220px'
        };
      case widthWide:
        return {
          width: '285px'
        };
      case widthWideFlex:
        return {
          fieldSizing: 'content',
          maxWidth: CoreUtils.isDefinedAndNotNull(this.props.width)
            ? this.props.width
            : '500px',
          minWidth: '285px'
        };
      default:
        return {
          width: defaultWidth
        };
    }
  }

  resolveControlWidth(metadataRule, defaultWidth) {
    switch (metadataRule.fieldWidth) {
      case widthNarrow:
        return '55px';
      case widthNarrowMedium:
        return '115px';
      case widthMedium:
        return '165px';
      case widthMediumWide:
        return '220px';
      case widthWide:
      case widthWideFlex:
        return '285px';
      default:
        return defaultWidth;
    }
  }

  renderDateTime() {
    switch (this.props.metadataRule.restrictionType) {
      case 'DateTime':
        return (<div />);
      case 'DateOnly':
        return (
          <DateEditor
            disabled={this.props.disabled}
            value={this.props.value}
            height={this.props.height}
            name={this.props.name}
            onValueChanged={this.props.onValueChanged}
            width={this.props.width}
          />
        );
      case 'DateOnlyStartOfMonth':
        return (
          <MonthEditor
            disabled={this.props.disabled}
            value={this.props.value}
            height={this.props.height}
            name={this.props.name}
            onValueChanged={this.props.onValueChanged}
            postEditFilter={DateTimeUtils.nudgeDateToFirstDayOfMonth}
            width={this.props.width}
          />
        );
      case 'DateOnlyEndOfMonth':
        return (
          <MonthEditor
            disabled={this.props.disabled}
            value={this.props.value}
            height={this.props.height}
            name={this.props.name}
            onValueChanged={this.props.onValueChanged}
            postEditFilter={DateTimeUtils.nudgeDateToLastDayOfMonth}
            width={this.props.width}
          />
        );
      default:
        return (<div />);
    }
  }
}